import { NavLink } from "react-router-dom";
import { useTheme } from "../hooks/useTheme";

const routes = [
  { path: "/", label: "Introduction" },
  { path: "/architecture", label: "Architecture" },
  { path: "/kiosk-flow", label: "Kiosk Flow" },
  { path: "/offline-mode", label: "Offline Mode" },
  { path: "/p2p-sync", label: "P2P Sync" },
  { path: "/payment-flow", label: "Payment Flow" },
  { path: "/security", label: "Security" },
  { path: "/api-reference", label: "API Reference" },
  { path: "/runbooks", label: "Runbooks" },
];

interface SidebarProps {
  readonly open: boolean;
  readonly onNavigate: () => void;
}

export function Sidebar({ open, onNavigate }: SidebarProps) {
  const { theme, toggle } = useTheme();
  const next = theme === "dark" ? "light" : "dark";
  return (
    <aside
      id="docs-sidebar"
      className={open ? "docs-sidebar docs-sidebar--open" : "docs-sidebar"}
    >
      <h1 className="docs-sidebar__title">Astra-Service Docs</h1>
      <button
        type="button"
        className="docs-sidebar__theme-toggle"
        onClick={toggle}
        aria-label={`Switch to ${next} mode (currently ${theme})`}
      >
        <span aria-hidden="true">{theme === "dark" ? "◐" : "◑"}</span>
        {theme === "dark" ? "Light mode" : "Dark mode"}
      </button>
      <nav aria-label="Documentation">
        <ul className="docs-sidebar__nav">
          {routes.map((route) => (
            <li key={route.path}>
              <NavLink
                to={route.path}
                end={route.path === "/"}
                onClick={onNavigate}
                className={({ isActive }) =>
                  isActive
                    ? "docs-sidebar__link docs-sidebar__link--active"
                    : "docs-sidebar__link"
                }
              >
                {route.label}
              </NavLink>
            </li>
          ))}
        </ul>
      </nav>
    </aside>
  );
}
